import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { backgroundsKeys } from './backgroundKeys';
import { useTranslation } from 'react-i18next';

export interface IBackgroundResponse {
  backgroundId: number;
  fileName: string;
  url: string;
  isGlobalDefault: boolean;
  customerId: number | null;
  default: boolean;
}

const getBackgrounds = async (): Promise<IBackgroundResponse[]> => {
  const response = await EXPRESS_API.get('/backgrounds');
  return response.data;
};

export const useQueryBackgrounds = () => {
  const { t } = useTranslation();
  return useQuery(backgroundsKeys.all(), () => getBackgrounds(), {
    onError: () => {
      errorToast({
        title: t(
          "We're currently experiencing difficulties fetching backgrounds."
        ),
      });
    },
  });
};
